(function() {
    'use strict';

    angular
        .module('bhsApp')
        .controller('ParamTableauDetailController', ParamTableauDetailController);

    ParamTableauDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ParamTableau', 'ParamFormulaire'];

    function ParamTableauDetailController($scope, $rootScope, $stateParams, previousState, entity, ParamTableau, ParamFormulaire) {
        var vm = this;

        vm.paramTableau = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bhsApp:paramTableauUpdate', function(event, result) {
            vm.paramTableau = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
